// roles

const mutations = {
	getRoles(state, objects) {
  		state.roles = objects;
	},
	getRole(state, object) {
  		state.role = object;
	},
	resetRole(state) {
  		state.role = {};
	},

};

export default mutations;